module.exports = __webpack_public_path__ + "img/18-1.37ddc5dd.jpg";